"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGamepadScale = exports.useScreenScale = exports.useScale = exports.useNormalize = exports.GamepadFontScale = exports.GamepadScale = exports.UnboaredScale = void 0;
const react_1 = require("react");
const utils_storage_1 = require("@unboared/utils.storage");
const react_native_1 = require("react-native");
//Default guideline sizes are based on standard ~5" screen mobile device
const guidelineBaseWidth = 350;
const guidelineBaseHeight = 680;
exports.UnboaredScale = {
    screen: 1.0,
    screenFont: 1.0,
    gamepad: 1.8,
    gamepadFont: 1.8,
};
exports.GamepadScale = exports.UnboaredScale.gamepad;
exports.GamepadFontScale = exports.UnboaredScale.gamepadFont;
const useNormalize = () => {
    const [width, setWidth] = (0, react_1.useState)(react_native_1.Dimensions.get('window').width);
    const [height, setHeight] = (0, react_1.useState)(react_native_1.Dimensions.get('window').height);
    const { scale, fontScale } = (0, exports.useScale)();
    const [shortDimension, longDimension] = width < height ? [width, height] : [height, width];
    const scaleFunction = (size) => (shortDimension / guidelineBaseWidth) * size;
    const verticalScale = (size) => (longDimension / guidelineBaseHeight) * size;
    const moderateScale = (size, factor = 0.5) => size + (scaleFunction(size) - size) * factor;
    const moderateVerticalScale = (size, factor = 0.5) => size + (verticalScale(size) - size) * factor;
    (0, react_1.useEffect)(() => {
        const handler = ({ window, screen }) => {
            setWidth(window.width);
            setHeight(window.height);
        };
        react_native_1.Dimensions.addEventListener('change', handler);
        return () => react_native_1.Dimensions.removeEventListener('change', handler);
    }, []);
    return {
        normalize: (px) => scale * moderateScale(px, 0.5),
        normalizeVertical: (px) => scale * moderateVerticalScale(px, 0.5),
        normalizeFont: (px) => fontScale * moderateScale(px, 0.5),
        moderateScale: (px, factor) => scale * moderateScale(px, factor),
        moderateFontScale: (px, factor) => fontScale * moderateScale(px, factor),
        moderateVerticalScale: (px, factor) => scale * moderateVerticalScale(px, factor),
    };
};
exports.useNormalize = useNormalize;
exports.useScale = (0, utils_storage_1.createGlobalStorage)((set, get) => ({
    scale: exports.UnboaredScale.screen,
    fontScale: exports.UnboaredScale.screen,
    setScale: (newScale) => set({ scale: newScale, fontScale: newScale }),
    setGamepadScale: () => get().setScale(exports.UnboaredScale.gamepad),
    setScreenScale: () => get().setScale(exports.UnboaredScale.screen),
    toggleScale: () => get().setScale(get().scale === exports.UnboaredScale.screen
        ? exports.UnboaredScale.gamepad
        : exports.UnboaredScale.screen),
}));
const useScreenScale = () => {
    const { setScreenScale } = (0, exports.useScale)();
    (0, react_1.useEffect)(() => {
        setScreenScale();
    }, []);
};
exports.useScreenScale = useScreenScale;
const useGamepadScale = () => {
    const { setGamepadScale } = (0, exports.useScale)();
    (0, react_1.useEffect)(() => {
        setGamepadScale();
    }, []);
};
exports.useGamepadScale = useGamepadScale;
//# sourceMappingURL=scale.js.map